import { render } from "./mOmicsNetwork.vue?vue&type=template&id=11313302"
import script from "./mOmicsNetwork.vue?vue&type=script&lang=js"
export * from "./mOmicsNetwork.vue?vue&type=script&lang=js"

import "./mOmicsNetwork.vue?vue&type=style&index=0&id=11313302&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__